<template>
	<div class="pagination-box" v-if="totalItem">
		<button class="btn-paging left" @click="listing('prev')"></button>
		<button
			:class="[
				'btn-paging',
				{ 'btn-paging--selected': currPage === cnt },
			]"
			v-for="cnt in pagingArr"
			:key="cnt"
			@click="to(cnt)"
		>
			{{ cnt }}
		</button>
		<button class="btn-paging right" @click="listing('next')"></button>
	</div>
</template>

<script>
	export default {
		name: 'PaginationBox',
		props: {
			totalItem: {
				type: Number,
				default: 0,
			},
			offset: {
				type: Number,
				default: 0,
			},
			limit: {
				type: Number,
				default: 10,
			},
			pageLengPerOne: {
				type: Number,
				default: 10,
			},
		},
		data() {
			return {
				totalPage: 0,
				firstPage: 0,
				currPage: 0,
			};
		},
		computed: {
			pagingArr() {
				const limit = this.limit;
				const pageLengPerOne = this.pageLengPerOne;
				const currPage = Math.floor(this.offset / limit) + 1;
				this.currPage = currPage;
				const totalPage = Math.ceil(this.totalItem / limit);
				this.totalPage = totalPage;
				const firstPage =
					Math.floor((currPage - 1) / pageLengPerOne) *
						pageLengPerOne +
					1;
				this.firstPage = firstPage;
				let pagingCnt = totalPage;
				const pagingArr = [];
				if (pagingCnt > pageLengPerOne) pagingCnt = pageLengPerOne;
				for (let idx = 0; idx < pagingCnt; idx++) {
					let page = firstPage + idx;
					if (page <= totalPage) pagingArr.push(page);
				}
				return pagingArr;
			},
		},
		methods: {
			listing(type) {
				const currPage = this.currPage;
				const totalPage = this.totalPage;
				if (
					(type === 'prev' && currPage <= 1) ||
					(type === 'next' && currPage >= totalPage)
				) {
					return;
				}
				const pageLengPerOne = this.pageLengPerOne;
				const limit = this.limit;
				let next = -1;
				if (type === 'next') {
					if (this.firstPage + pageLengPerOne > totalPage) {
						this.$emit('to', { offset: (totalPage - 1) * limit });
						return;
					}
					next = 1;
				}
				let offset =
					(Math.floor((currPage - 1) / pageLengPerOne) + next) *
					pageLengPerOne *
					limit;
				if (offset < 0) offset = 0;
				this.$emit('to', { offset });
			},
			to(targetPage) {
				const offset = (targetPage - 1) * this.limit;
				if (offset === this.offset) return;
				this.$emit('to', { offset });
			},
		},
	};
</script>

<style lang="scss">
	@import '@/assets/style/sprite.scss';

	DIV.pagination-box {
		text-align: center;

		.btn-paging {
			height: 28px;
			line-height: 28px;
			color: #7c7c7c;
			font-size: 0.9375rem;
			font-weight: normal;
			margin: 0 5px;
			padding: 0 5px;

			&.left,
			&.right {
				padding: 0;
				@extend .sprite;
			}

			&.left {
				@extend .btn-pn-left-nor;

				&:hover {
					@extend .btn-pn-left-sel;
				}
			}

			&.right {
				@extend .btn-pn-right-nor;

				&:hover {
					@extend .btn-pn-right-sel;
				}
			}

			@media (max-width: 768px) {
				padding: 0;
			}
		}

		.btn-paging--selected {
			color: #222;
			font-weight: bold;
		}
	}
</style>
